import { TextProps } from '@chakra-ui/react';
import { SyntheticEvent } from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { MIcon, MLink, MText } from '../Monetize';
import {
  ExternalRecordLinkConfig,
  getExternalRecordUrl,
} from './getExternalRecordUrl';

interface TargetIdCellProps {
  targetId?: string | null;
  targetSystemType: string;
  entityName: string;
  linkConfig: ExternalRecordLinkConfig;
  textProps?: TextProps;
}

// This cell renders inside a DataTable row that navigates to the log detail on
// click, and on middle pointer-down — so opening the external record must not
// also activate the row.
const stopPropagation = (event: SyntheticEvent) => event.stopPropagation();

export function TargetIdCell({
  targetId,
  targetSystemType,
  entityName,
  linkConfig,
  textProps,
}: TargetIdCellProps) {
  if (!targetId) {
    return null;
  }

  const url = getExternalRecordUrl(
    targetSystemType,
    entityName,
    targetId,
    linkConfig,
  );

  if (!url) {
    return <MText {...textProps}>{targetId}</MText>;
  }

  return (
    <MLink
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      color="tIndigo.base"
      onClick={stopPropagation}
      onPointerDown={stopPropagation}
    >
      {targetId}
      <MIcon as={FiExternalLink} ml="1" color="tIndigo.base" />
    </MLink>
  );
}
